import autobind from "autobind-decorator";
import delegate from "es6-delegate";
import Notification from "../Notification";
import { lazyValidate, ValidationError } from "../lazyValidate";

export default class ItemNumber {
  get input() {
    return this.form.querySelector("[name=item_number]");
  }

  get suffixDropdown() {
    return this.form.querySelector('[name="item_number"]') || {};
  }

  get withoutSpaces() {
    return `${this.toString().replace(/ /g, "")}`;
  }

  get unselectedSuffixMessage() {
    return this.input.firstElementChild.textContent.toLowerCase();
  }

  get unselectedSuffixItem() {
    return this.toString() === "0";
  }

  get selectedSuffixOption() {
    return (
      (this.suffixDropdown.options &&
        this.suffixDropdown.options[this.suffixDropdown.selectedIndex]) || {
        dataset: {},
      }
    );
  }

  get autoReorderEligible() {
    return this.selectedSuffixOption.dataset.isAutoReorderEligible;
  }

  constructor(form) {
    this.form = form;
    delegate(this.form, "change", '[name="item_number"]', this.change);
  }

  createSelectSuffixNotification() {
    const message = this.input.firstElementChild.textContent.toLowerCase();

    new Notification({ heading: `Please ${message}` });
    this.input.focus();
  }

  showCustomizationUrl() {
    const customizationButton = document.querySelector(".btn-custom");

    if (!customizationButton) return;

    const { selectedSuffixOption } = this;
    const {
      customizationUrl,
      customizationRequired,
      unavailable,
    } = selectedSuffixOption.dataset;

    if (customizationUrl !== "" && unavailable !== "Y") {
      customizationButton.href = customizationUrl;
      customizationButton.hidden = false;
    } else if (customizationRequired === "1" && unavailable !== "Y") {
      customizationButton.href = customizationButton.dataset.requiredHref;
      customizationButton.hidden = false;
    } else {
      customizationButton.href = "#";
      customizationButton.hidden = true;
    }
  }

  toString() {
    return this.input.value;
  }

  @lazyValidate
  suffix() {
    if (this.unselectedSuffixItem) {
      this.input.classList.add("input_error");
      this.input.focus();
      throw new ValidationError(
        `Please ${this.unselectedSuffixMessage} for this product.`
      );
    }

    this.input.classList.remove("input_error");
  }

  @autobind
  change() {
    const itemNumberChange = new Event("ItemNumber.change", { bubbles: true });
    itemNumberChange.detail = this;
    this.showCustomizationUrl();

    this.form.dispatchEvent(itemNumberChange);
  }
}
